<template>
    <div>
        <div v-if="address.primary" class="address__primary">{{ strings['address_primary'] }}</div>
        <div v-else v-on:click="$emit('set-primary', address.id)" class="address__button address__button--primary">{{ strings['address_set_primary'] }}</div>
        <div class="address__body">
            <b>{{ address.name }} {{ address.surname }}</b><br>
            <span v-if="address.company_name || address.companyName">
                {{ address.company_name || address.companyName }}<br>
            </span>
            {{ address.address }}<br>
            {{ address.city }}, {{ address.zip_code }} {{ address.district }}<br>
            <div class="pv2">{{ address.telephone }}</div>
        </div>
        <hr>
        <div class="flex items-center justify-between">
            <div class="address__button address__button--change" v-on:click="$emit('load-address', address.id)">{{ strings['address_modify'] }}</div>
            <div v-if="disabled === false" class="address__button address__button--remove" v-on:click="$emit('remove-address', address.id)">{{ strings['address_delete'] }}</div>
        </div>
    </div>
</template>

<script>
module.exports = {
    props: ['address', 'strings', 'disabled']
}
</script>
